import { Component, Host, h } from '@stencil/core';

export interface AhaEmptyStateLarge extends HTMLAhaEmptyStateLargeElement {}

/**
 * Custom empty state component that can render an image, title, body and actions.
 * @slot image - Slot used to render an image/figure on the left side of the component.
 * @slot title - Contents of the title of the component.
 * @slot body - Contents of the body of the component.
 * @slot actions - Contents of the actions of the component.
 */
@Component({
  tag: 'aha-empty-state-large',
  styleUrl: 'aha-empty-state-large.css',
  shadow: true,
})
export class AhaEmptyStateLarge {
  render() {
    return (
      <Host>
        <slot name="image"></slot>
        <div>
          <slot name="title"></slot>
          <slot name="body"></slot>
          <slot name="actions"></slot>
        </div>
      </Host>
    );
  }
}
